@use '../../../../assets/styles/utilities.scss';

:host {
  display: block;
}

select {
  appearance: none; // For most browsers
  -webkit-appearance: none; // For Safari/Chrome
  -moz-appearance: none; // For Firefox
  background: none; // Remove background if needed
}
